<template>
    <div :class="['calendario', `calendario-${data.calendarPosition}`]" v-loading="loading">
        
        <!-- Error -->
        <template v-if="error">
            <el-row style="padding: 10px; min-height: 150px">
                <el-col :span="24">
                    <div class="empty">
                        <img src="../../assets/Error.png">
                        <p>Ha ocurrido un error</p>
                    </div>
                </el-col>
            </el-row>
        </template>
        <template v-else>

            <!-- Leyenda -->
            <div class="legend" v-if="calendarios && data && data.events">
                <template v-for="(evento,e) in data.events">
                    <div 
                        v-if="evento.visible"
                        class="event"
                        :style="{backgroundColor: evento.color, color: evento.colorText || 'white'}" 
                        :key="`e_${e}`"
                        >
                            <p>{{evento.name}}</p>
                            <span :style="{color: evento.colorText || evento.color}" v-if="evento.days">{{evento.days}}</span>
                    </div>
                </template>
            </div>

            <!-- Calendario -->
            <div class="calendarios" v-if="calendarios">
                <table border="0" v-for="(calendario,c) in calendarios" :key="c" :class="[{editing: solicitar.event}]">
                    <thead>
                        <tr class="header">
                            <td colspan="7">{{moment(calendario.mes, 'M').locale('es').format('MMMM')}}</td>
                        </tr>
                        <tr>
                            <td>L</td>
                            <td>M</td>
                            <td>X</td>
                            <td>J</td>
                            <td>V</td>
                            <td>S</td>
                            <td>D</td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(semana, d) in calendario.semanas">
                            <tr :key="`c_${c}_d_${d}`">
                                <template v-for="dia in semana">
                                    <td
                                        @click="solicitarDia(dia)"
                                        :class="[
                                            {disabled: dia.dia && dia.dia.disabled},
                                            {solicitado: dia.dia && dia.dia.current && solicitar.days.length && solicitar.days.find(f => f.dia.current === dia.dia.current)}
                                        ]">
                                        <div class="cell" :style="{
                                            backgroundColor: dia.dia && dia.dia.event ? dia.dia.event.color : '', 
                                            color: dia.dia && dia.dia.event ? dia.dia.event.colorText : ''
                                        }">
                                        {{dia.dia ? dia.dia.dia : ''}}
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <!-- Solicitar dias -->
            <div class="solicitar" v-if="calendarios && data.events && data.urlGuardado">
                <div class="solicitar-content">
                    <el-button
                        v-if="!solicitar.show"
                        style="min-width: 200px"
                        type="primary"
                        size="small" 
                        @click="solicitar.show = true">
                        Crear solicitud <i class="el-icon-plus el-icon-right"></i>
                    </el-button>
                    
                    <div class="solicitar-form" v-else>
                        <p>Selecciona el tipo de ausencia y después marca en el calendario los días que deseas.</p>
                        <div class="solicitar-acciones">
                            <el-select 
                                :disabled="solicitar.event ? true : false"
                                v-model="solicitar.event" 
                                placeholder="Selecciona" 
                                style="width: 100%;margin-bottom: 5px"
                                size="small">
                                    <el-option
                                    v-for="(event, e) in data.events.filter(f => f.select)"
                                    :key="event.id"
                                    :label="event.name"
                                    :value="event.id">
                                    </el-option>
                            </el-select>
                        
                            <el-button
                                :disabled="!solicitar.days.length"
                                style="width: 100%;margin-bottom: 5px"
                                type="primary"
                                size="small" 
                                @click="enviarSolicitud()">Enviar
                            </el-button>
                        
                            <el-button
                                style="width: 100%; margin: 0"
                                size="small" 
                                @click="cancelarSolicitud()">Cancelar
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

        </template>

    </div>
</template>

<script>
import moment from 'moment'

import {
    getCalendarioEstructura,
    getCalendarioDatos,
    guardarSolicitud
} from '@/helpers/api'

export default {
    name: 'Calendario',
    data() {
        return {
            moment,
            loading: false,
            error: false,

            periodo: null,
            data: {
                events: null,
                days: null,
                urlGuardado: null,
                calendarPosition: 'center',
                periodo: null
            },

            // Solicitar dias
            solicitar: {
                show: false,
                event: null,
                days: []
            },

            // Conjunto de todos los meses
            calendarios: []
        }
    },
    mounted() {
        this.init()
        this.$emit('created')
    },
    methods: {
        async init() {
            this.calendarios = []
            await this.getEstructura()
            this.generarCalendario()
        },
        async getEstructura() {
            
            this.error = false

            this.loading = true

            try {
                
                let { data } = await getCalendarioEstructura()
                //let resp = await(await fetch('/test_local/calendario_estructura.json', { method: 'GET' })).json()
                
                this.periodo = {
                    inicio: data.data.inicio,
                    fin: data.data.fin
                }

                this.data.events = data.data.events
                this.data.urlGuardado = data.data.urlGuardado || null
                this.data.calendarPosition = data.data.calendarPosition
                this.data.periodo = data.data.periodo

                await this.getData()

            } catch(err) {
                this.error = true
            }

            this.loading = false

        },
        async getData() {
            
            this.error = false

            this.loading = true

            try {

                let { data } = await getCalendarioDatos()
                //let resp = await (await fetch('/test_local/calendario_data.json', { method: 'GET' })).json()
                
                if (data.data && data.data.days) this.data.days = data.data.days

            } catch(err) {
                //console.log('error cacth datos')
                this.error = true
            }

            this.loading = false
            
        },
        generarCalendario() {

            let inicio = moment(this.periodo.inicio, 'DD/MM/YYYY')
            let fin = moment(this.periodo.fin, 'DD/MM/YYYY')

            this.getDaysBetweenDates(inicio, fin).forEach(date => {
                this.calendarios.push({
                    mes: date.mes,
                    semanas: this.generarEstructura(date.dias)
                })
            })
        },
        getDaysBetweenDates(startDate, endDate) {

            let now = startDate.clone()
            let dates = []
            let dias = []
            let mes_actual = now.format('MM')

            let _self = this
            function finalizar_mes () {

                // Insertar dias finales
                let days_month = moment(mes_actual, 'MM',).daysInMonth()
                if (dias.length < days_month) {
                    for(let i=dias.length; i < days_month; i++) {
                        dias.push({
                            current: now.format(`DD/MM/YYYY`),
                            position: +moment(now.format(`${i + 1}/MM/YYYY`), 'DD/MM/YYYY').format('E'),
                            dia: i + 1,
                            disabled: true,
                            event: _self.data.days ? _self.getEventById(_self.data.days[now.format(`DD/MM/YYYY`)] || 0) : null
                        })
                    }
                }

                dates.push({
                    mes: mes_actual,
                    dias,
                    disabled: false
                })

                dias = []
            }

            while (now.isSameOrBefore(endDate)) {
                
                if(mes_actual && mes_actual !== now.format('MM')) finalizar_mes()

                // Rellenar dias inicio
                if(!dias.length && +now.format('D') !== 1) {
                    for(let i=1; i < +now.format('D'); i++) {
                        dias.push({
                            current: now.format(`DD/MM/YYYY`),
                            position: +moment(now.format(`${i}/MM/YYYY`), 'DD/MM/YYYY').format('E'),
                            dia: i,
                            disabled: true,
                            event: this.data.days ? this.getEventById(this.data.days[now.format(`DD/MM/YYYY`)] || 0) : null
                        })
                    }
                }

                // Insertar dia
                dias.push({
                    current: now.format(`DD/MM/YYYY`),
                    position: +now.format('E'),
                    dia: +now.format('D'),
                    event: this.data.days ? this.getEventById(this.data.days[now.format(`DD/MM/YYYY`)] || 0) : null
                })

                mes_actual = now.format('MM')

                now.add(1, 'days')

                if (!now.isSameOrBefore(endDate)) finalizar_mes()

            }
            
            return dates
        },
        generarEstructura(dias) {

            let mes = []
            let semana = []
            let posicion = 1
            let dias_ordered = dias.sort((a,b) => +a.dia - +b.dia)
            
            for(let i=0; i<dias_ordered.length; i++) {

                let dia = dias_ordered[i]
                
                // Rellenar dias iniciales
                if(posicion == 1) {
                    for(let d = 0; d<dia.position - 1; d++) {
                        semana.push({})
                        posicion++
                    }
                }

                // Insertar dia
                if (posicion === dia.position) semana.push({dia})

                // Rellenar dias finales
                if(i === dias_ordered.length - 1){
                    for(let d = dia.position; d<7; d++) {
                        semana.push({})
                        posicion++
                    }
                }

                // Control de fin de semana
                if(dia.position === 7 || posicion === 7) {
                    mes.push(semana)
                    semana = []
                    posicion = 1
                } else {
                    posicion++
                }
            }

            return mes
        },
        getEventById (event_id) {
            return this.data.events.find(f => f.id === event_id)
        },
        refreshData() {
            this.init()
        },

        // Solicitud
        solicitarDia(dia) {

            if (!this.solicitar.event || !dia.dia || dia.dia.disabled) return

            let day_exist = this.solicitar.days.findIndex(f => f.dia.current === dia.dia.current)
            if (!!~day_exist) {
                this.solicitar.days.splice(day_exist, 1)
            } else {
                this.solicitar.days.push(dia)
            }
        },
        async enviarSolicitud() {

            this.loading = true

            try {

                let resp = await guardarSolicitud({
                    param: this.data.urlGuardado,
                    data: {
                        periodo_id: +this.data.periodo,
                        dias: this.solicitar.days.map(m => {
                            return {
                                day: m.dia.current,
                                event: this.solicitar.event
                            }
                        })
                    }
                })

                this.$emit('saved', resp.data)

                await this.getData()

                this.cancelarSolicitud()

            } catch (err) {

                this.cancelarSolicitud()

                this.$notify.error({
                    title: 'Error',
                    message: 'THa ocurrido un error'
                })
            }

            this.loading = false
        },
        cancelarSolicitud() {
            this.solicitar.event = null
            this.solicitar.days = []
            this.solicitar.show = false
        }
    }
}
</script>

<style lang="scss">
.calendario {
    display: flex;
    flex-wrap: wrap;
    min-height: 200px!important;

    &.calendario-right {
        display: grid;
        grid-gap: 0px;
        grid-template-columns: 250px auto;
        .legend {
            grid-column: 1;
            grid-row: auto;
            flex-flow: column;
            padding: 10px;
            width: auto;
            .event {
                margin: 0 0 5px;
            }
        }
        .calendarios {
            grid-column: 2 ;
		    grid-row: span 3;
            table {
                max-width: 175px;
            }
        }
        .solicitar {
            grid-column: 1;
            width: auto;
            .solicitar-content {
                padding: 10px;
                flex-flow: column;
                > button {
                    width: 100%;
                }
                .solicitar-form {
                    p {
                        margin: 0 0 0.5rem;
                    }
                    .solicitar-acciones {
                        flex-flow: column;
                        button, 
                        .el-select {
                            margin: 0 0 0.5rem!important;
                            &:last-child {
                                margin-left: 0!important;
                            }
                        }
                    }
                }
            }
        }
    }

    .calendarios {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        justify-content: space-evenly;
        padding: 5px;

        table {
            border-spacing: 0px;
            border-collapse: collapse;
            max-width: 170px;
            margin: 5px;
            &.editing {
                tbody {
                    td {
                        cursor: pointer;
                        &:hover {
                            background-color: #dfeeff;
                        }
                    }
                }
            }
            thead {
                tr {
                    &.header {
                        td {
                            background-color: #afbac7;
                            font-size: .8rem;
                            padding: 0.10rem 0.50rem;
                            text-transform: capitalize;
                        }
                    }
                    td {
                        //border: 1px solid #e9e9eb;
                        width: 130px;
                        font-size: .6rem;
                        font-weight: 700;
                        color: #0000009c;
                        text-align: center;
                        background-color: #fafafa;
                    }
                }
            }
            tbody {
                td {
                    //border: 1px solid #e9e9eb;
                    text-align: center;
                    font-size: 0.7rem;
                    padding: 0px!important;
                    width: calc(100% / 7);
                    position: relative;
                    &:after {
                        content: "";
                        display: block;
                        padding-bottom: 100%;
                    }
                    &.disabled {
                        opacity: 0.3;
                    }
                    &.solicitado {
                        background-color: #ffeeb9 !important;
                        .cell {
                            background-color: #ffeeb9 !important;
                            color: #4a596a!important;
                        }
                    }
                    > div.cell {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }

    .legend {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 2px;
        > .event {
            padding: 0.2rem 0.20rem;
            border-radius: 30px;
            color: white;
            margin: 5px;
            font-size: 0.8rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: fit-content;
            p {
                margin: 0px 6px;
            }
            span {
                background-color: white;
                height: 17px;
                width: 17px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                color: #4a596a;
                font-size: 0.7rem;
            }
        }
    }

    .solicitar {
        width: 100%;
        padding: 2px;
        margin-top: 10px;
        .solicitar-content {
            padding: 10px;
            flex-flow: row;
            > button {
                width: 100%;
            }
            .solicitar-form {
                p {
                    margin: 0 0 0.5rem;
                    font-size: 0.8rem;
                    margin-bottom: 5px;
                    font-weight: 700;
                }
                .solicitar-acciones {
                    display: flex;
                    flex-flow: row;
                    .el-select {
                        flex-grow: 1;
                        margin: 0 0.5rem 0 0!important;
                        width: auto!important;
                    }
                    button {
                        width: auto!important;
                        margin: 0px!important;
                        &:last-child {
                            margin-left: 0.5rem!important;
                        }
                    }
                }
                
            }
        }
    }
}
</style>